module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// ./~/vue-msal/~/axios/index.js
// module id = 1350
// module chunks = 0